import { avatarUrl } from '@/shared/lib/avatar';

import styles from './ui.module.css';

export interface AvatarProps {
  avatar: string;
  name: string;
  size?: number;
}

/** A round avatar; falls back to the first letter of the name. */
export function Avatar({ avatar, name, size = 32 }: AvatarProps): React.JSX.Element {
  const url = avatarUrl(avatar);

  if (url === undefined) {
    return (
      <span
        className={styles.avatarFallback}
        style={{ width: size, height: size, fontSize: size * 0.45 }}
        aria-hidden="true"
      >
        {name.slice(0, 1).toUpperCase()}
      </span>
    );
  }

  return <img className={styles.avatar} src={url} alt="" width={size} height={size} />;
}
